import { render, staticRenderFns } from "./AddSpecialMinimalPrice.vue?vue&type=template&id=a4b4efb8&scoped=true"
import script from "./AddSpecialMinimalPrice.vue?vue&type=script&lang=js"
export * from "./AddSpecialMinimalPrice.vue?vue&type=script&lang=js"
import style0 from "./AddSpecialMinimalPrice.vue?vue&type=style&index=0&id=a4b4efb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4b4efb8",
  null
  
)

export default component.exports